import { Agent, AgentKeys } from '@ag-common-lib/public-api';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'agentInfoModalTitle' })
export class AgentInfoModalTitlePipe implements PipeTransform {
  constructor() {}

  async transform(agent: Agent): Promise<string> {
    const agentFirstName = agent?.[AgentKeys.p_agent_first_name];
    const agentLastName = agent?.[AgentKeys.p_agent_last_name];
    const email = agent?.[AgentKeys.p_email];
    const agentId = agent?.[AgentKeys.p_agent_id];
    const agentStatus = agent?.[AgentKeys.agent_status];

    let title = '';

    const agentFullName = [agentFirstName, agentLastName].filter(Boolean).join(' ');

    if (agentFullName) {
      title += `${agentFullName}`;
    }
    if (email) {
      title += ` (${email})`;
    }
    if (agentStatus) {
      title += ` - ${agentStatus}.`;
    }
    return title;
  }
}
